<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage">
<a id="title17"></a>
<div class="tp-author"><strong class="b">ELIZABETH BEVARLY</strong></div>
<div class="tp-title"><strong class="b">LUCY AND THE LONER</strong></div>
<div class="illustype_image_text"><div class="image_text"><img alt="9781459271517_i0003.jpg" src="9781459271517_i0003.jpg"/></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459271517_tp01.vue?26a596cb